'use strict';

const Globals = require('../globals');

const TraitsUtil = {
    _checkTraitInObject: function(traitsObj={}, traitName) {
        return (
            !!traitsObj
            && !!traitsObj[traitName]
        );
    },

    canReviewActivity: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'canReview');
    },

    // activity trait which disables display of overall score
    shouldHideOverallScore: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'hideOverallScore');
    },

    // activity trait which swaps default showing of percent score for fractional score
    shouldShowFractionScore: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'showFractionScore');
    },

    shouldShowNotIncludedInScoring: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'showNotInludedInScoring');
    },

    canConfigureWeights: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'canConfigureWeights');
    },

    isMultiplayer: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'isMultiplayer');
    },

    isTeam: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'isTeam');
    },

    canConfigureStartDate: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'isMultiplayer');
    },

    canConfigureEndDate: function(traits={}, turnType=null) {
        return (
            TraitsUtil._checkTraitInObject(traits, 'isMultiplayer')
            && (
                turnType === Globals.assignment.turn_type.MANUAL
                || turnType === Globals.assignment.turn_type.INSTRUCTOR_CONTROLLED
            )
        );
    },

    hasMetaOptions: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'hasMetaOptions');
    },

    getMinUsersReqForScRangeStats: function(traits={}) {
        return traits['minUsersReqForScRangeStats'] || 0;
    },

    canConfigureNumTurns: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'canConfigureNumTurns');
    },

    canConfigureOpenEnrollment: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'isMultiplayer');
    },
    
    allowCompletionScoring: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'allowCompletionScoring');
    },

    getDefaultTurns: function(traits={}) {
        return traits['defaultTurns'] || null;
    },

    getMinTurns: function(traits={}) {
        return traits['minTurns'] || null;
    },

    getMaxTurns: function(traits={}) {
        return traits['maxTurns'] || null;
    },

    getTurnTypes: function(traits={}) {
        if (!TraitsUtil._checkTraitInObject(traits, 'turnTypes')) {
            return null;
        }

        let validatedTraits = [];
        Object.keys(Globals.assignment.turn_type)
            .forEach((turnTypeKey) => {
                const turnTypeValue = Globals.assignment.turn_type[turnTypeKey];
                if (traits['turnTypes'].indexOf(turnTypeValue) >= 0) {
                    validatedTraits.push(turnTypeValue);
                }
            });

        if (validatedTraits.length > 0) {
            return validatedTraits;
        }
        else {
            return null;
        }
    },

    getFiatTurnType: function(turnTypeToken) {
        switch (turnTypeToken) {
            case Globals.assignment.turn_type.MANUAL: {
                return Globals.assignment.turn_type_fiat.OFF;
            }
            case Globals.assignment.turn_type.SCHEDULED:
            case Globals.assignment.turn_type.INSTRUCTOR_CONTROLLED: {
                return Globals.assignment.turn_type_fiat.EXTERNAL;
            }
            default: {
                return null;
            }
        }
    },

    assignmentAllowsForcedTurnEndings: function(turnTypeToken) {
        switch (turnTypeToken) {
            case Globals.assignment.turn_type.SCHEDULED:
            case Globals.assignment.turn_type.INSTRUCTOR_CONTROLLED: {
                return true;
            }
            case Globals.assignment.turn_type.MANUAL: 
            default: {
                return false;
            }
        }
    },

    hasBreakingChange: function(oldTraits={}, newTraits={}) {
        if (TraitsUtil.isMultiplayer(oldTraits) !== TraitsUtil.isMultiplayer(newTraits)) return true;
        if (TraitsUtil.isTeam(oldTraits) !== TraitsUtil.isTeam(newTraits)) return true;

        return false;
    },

    hasReviewMode: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'reviewMode');
    },

    hasMarketingCustom1Export: function(traits={}) {
        return TraitsUtil._checkTraitInObject(traits, 'hasMarketingCustom1Export');
    },
};

module.exports = TraitsUtil;